import { Formik } from "formik";
import Button from "../../commons/Button/Button";
import useOneTimeNotification, {
  OneTimeNotificationReqVariables,
} from "../../state/hooks/one-time-notifications/useOneTimeNotifications";
import { notification } from "antd";
const initialValue: OneTimeNotificationReqVariables = {
  timeToReceive: undefined,
  // if [] sended to all
  platform: ["android", "ios", "web"],
  // if undefined sended to ALL,
  premium: false,
  // if [] sended to all
  notificationType: ["learning"],
  olderThanDays: 0,
  earlierThanDays: 0,
  premiumTobeCancelled: false,
  premiumNotTobeCancelled: false,
  spreadTime: 0,
};
const OneTimeNotifications = () => {
  const { mutate: mutateAsync } = useOneTimeNotification({
    onSuccess: () => {
      notification.success({
        message: "Success",
        description: "Notification sent successfully",
        placement: "top", // Optional: Controls the position of the popup
      });
    },
    onError: () => {
      notification.error({
        message: "Error",
        description: "Error sending notification",
        placement: "top", // Optional: Controls the position of the popup
      });
    },
  });

  return (
    <div className="flex justify-center items-center h-screen">
      <Formik
        initialValues={initialValue}
        validateOnChange={true}
        validate={(values) => {
          const errors: Partial<Record<keyof typeof values, string>> = {};

          if (!values.timeToReceive) {
            errors.timeToReceive = "Time to receive is required";
          } else {
            const timeToReceiveRegex = /^(0?[1-9]|1[0-2]):[0-5]?[0-9](AM|PM)$/;
            if (!timeToReceiveRegex.test(values.timeToReceive)) {
              errors.timeToReceive =
                "Invalid time format. Use HH:MMAM/PM format";
            }
          }

          if (values.olderThanDays < 0) {
            errors.olderThanDays = "Age filter must be a positive number";
          }
          return errors;
        }}
        onSubmit={(values) => {
          const timeToReceiveRegex = /^(0?[1-9]|1[0-2]):[0-5]?[0-9](AM|PM)$/;
          if (
            values.timeToReceive &&
            timeToReceiveRegex.test(values.timeToReceive)
          ) {
            const lastSubmittedNotifications = localStorage.getItem(
              "lastSubmittedNotifications"
            );
            const now = new Date().getTime();
            if (
              !lastSubmittedNotifications ||
              now - parseInt(lastSubmittedNotifications) > 2 * 60 * 1000
            ) {
              const allPlatform =
                values.platform.includes("web") &&
                values.platform.includes("ios") &&
                values.platform.includes("android")
                  ? []
                  : values.platform;
              localStorage.setItem(
                "lastSubmittedNotifications",
                now.toString()
              );

              mutateAsync({
                timeToReceive: values.timeToReceive,
                platform: allPlatform,
                notificationType: values.notificationType,
                olderThanDays: +values.olderThanDays,
                earlierThanDays: +(values.earlierThanDays ?? 0),
                premium: values.premium === false ? false : undefined,
                premiumTobeCancelled: values.premium === undefined ? undefined : (values.premiumTobeCancelled || undefined),
                premiumNotTobeCancelled: values.premium === undefined ? undefined : (values.premiumNotTobeCancelled || undefined),
                spreadTime: values.spreadTime,
              });
            }
          }
        }}
      >
        {({
          values,
          setFieldValue,
          handleSubmit,
          handleBlur,
          setFieldTouched,
          errors,
        }) => {
          return (
            <form
              onSubmit={handleSubmit}
              className="bg-white p-8 rounded shadow-md w-96"
            >
              <div className="mb-4">
                <label className="block">Time to receive</label>
                <input
                  type="text"
                  name="timeToReceive"
                  placeholder="Enter time to receive (HH:MMAM/PM)"
                  value={values.timeToReceive}
                  onChange={(e) => {
                    setFieldTouched("timeToReceive", true);
                    setFieldValue("timeToReceive", e.target.value);
                  }}
                  onBlur={handleBlur}
                  className="w-full p-2 border border-gray-300 rounded"
                />
                <div className="text-gray-500 text-xs mt-1">
                  Format: 10:30AM or 2:45PM
                </div>
                {errors.timeToReceive && (
                  <div className="text-error text-sm mt-1">
                    {errors.timeToReceive}
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label className="block">Older Than (days)</label>
                <input
                  type="number"
                  name="olderThanDays"
                  placeholder="Enter older than (days)"
                  min={0}
                  value={values.olderThanDays}
                  onChange={(e) => {
                    const value = e.target.value;
                    const numValue = parseInt(value, 10);
                    setFieldValue("olderThanDays", numValue >= 0 ? numValue : 0);
                  }}
                  onBlur={handleBlur}
                  className="w-full p-2 border border-gray-300 rounded"
                />
                {errors.olderThanDays && (
                  <div className="text-error text-sm mt-1">
                    {errors.olderThanDays}
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label className="block">Earlier Than (days)</label>
                <input
                  type="number"
                  name="earlierThanDays"
                  placeholder="Enter earlier than (days)"
                  min={0}
                  value={values.earlierThanDays}
                  onChange={(e) => {
                    const value = e.target.value;
                    const numValue = parseInt(value, 10);
                    setFieldValue("earlierThanDays", numValue >= 0 ? numValue : 0);
                  }}
                  onBlur={handleBlur}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>

              <div className="mb-4">
                <label className="block">Spread Time</label>
                <input
                  type="number"
                  name="spreadTime"
                  placeholder="Enter spread time"
                  min={0}
                  value={values.spreadTime}
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    if (value >= 1 || e.target.value === "") {
                      setFieldValue("spreadTime", value >= 1 ? value : 1);
                    }
                  }}
                  onBlur={handleBlur}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>
              <div className="mb-4">
                <label className="block">Notification Type</label>
                <select
                  value={values.notificationType}
                  onChange={(e) => {
                    setFieldTouched("notificationType", true);
                    if (e.target.value === "all") {
                      setFieldValue("notificationType", []);
                    } else {
                      setFieldValue("notificationType", [e.target.value]);
                    }
                  }}
                  className="w-full p-2 border border-gray-300 rounded"
                >
                  <option value="marketing">marketing</option>
                  <option value="learning">learning</option>
                  <option value="all">all</option>
                </select>
              </div>
              <div>
                <label>Platform</label>
                <div className="mb-4 flex-row flex justify-around ">
                  <label className={"flex items-center"}>
                    <input
                      type="checkbox"
                      name="platform"
                      checked={values.platform.includes("web")}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFieldValue("platform", [
                            ...values.platform,
                            "web",
                          ]);
                        } else {
                          setFieldValue(
                            "platform",
                            values.platform.filter(
                              (platform) => platform !== "web"
                            )
                          );
                        }
                      }}
                      className="mr-2"
                    />
                    web
                  </label>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      name="platform"
                      checked={values.platform.includes("ios")}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFieldValue("platform", [
                            ...values.platform,
                            "ios",
                          ]);
                        } else {
                          setFieldValue(
                            "platform",
                            values.platform.filter(
                              (platform) => platform !== "ios"
                            )
                          );
                        }
                      }}
                      className="mr-2"
                    />
                    ios
                  </label>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      name="platform"
                      checked={values.platform.includes("android")}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFieldValue("platform", [
                            ...values.platform,
                            "android",
                          ]);
                        } else {
                          setFieldValue(
                            "platform",
                            values.platform.filter(
                              (platform) => platform !== "android"
                            )
                          );
                        }
                      }}
                      className="mr-2"
                    />
                    android
                  </label>
                </div>
              </div>

              <div>
                <label>Premium To Be Cancelled</label>
                <div className="mb-4 flex-row flex justify-around ">
                  <label className={"flex items-center"}>
                    <input
                      type="checkbox"
                      name="premiumTobeCancelled"
                      checked={values.premium === undefined ? false : values.premiumTobeCancelled}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFieldValue("premiumTobeCancelled", true);
                          setFieldValue("premiumNotTobeCancelled", false);
                        } else {
                          setFieldValue("premiumTobeCancelled", false);
                        }
                      }}
                      disabled={values.premium === undefined}
                      className="mr-2"
                    />
                    Premium To Be Cancelled
                  </label>
                </div>
              </div>
              <div>
                <label>Premium Not To Be Cancelled</label>
                <div className="mb-4 flex-row flex justify-around ">
                  <label className={"flex items-center"}>
                    <input
                      type="checkbox"
                      name="premiumNotTobeCancelled"
                      checked={values.premium === undefined ? false : values.premiumNotTobeCancelled}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFieldValue("premiumNotTobeCancelled", true);
                          setFieldValue("premiumTobeCancelled", false);
                        } else {
                          setFieldValue("premiumNotTobeCancelled", false);
                        }
                      }}
                      disabled={values.premium === undefined}
                      className="mr-2"
                    />
                    Premium Not To Be Cancelled
                  </label>
                </div>
              </div>
              <div>
                <label>Send To</label>
                <div className="mb-4 flex-row flex justify-around ">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      name="premium"
                      checked={values.premium === false}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFieldValue("premium", false);
                        } else {
                          setFieldValue("premium", null);
                        }
                      }}
                      className="mr-2"
                    />
                    basic
                  </label>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      name="premium"
                      checked={values.premium === undefined}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFieldValue("premium", undefined);
                        } else {
                          setFieldValue("premium", null);
                        }
                      }}
                      className="mr-2"
                    />
                    all
                  </label>
                </div>
              </div>

              <Button buttonType="submit" type="main">
                Submit
              </Button>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default OneTimeNotifications;
